import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast, ToastContainer } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";

const MapDesignationsAndPackage = ({ isOpen, onRequestClose, designationId, companyId }) => {
  const navigate = useNavigate();
          const token = JSON.parse(localStorage.getItem("data")).token;

  const [designationPackage, setDesignationPackage] = useState({
    packageid: "",
    designationid: designationId,
    gender: [],
    age: [],
  });

  const [loading, setLoading] = useState(false);
  const [packages, setPackages] = useState([]);
  const [designations, setDesignations] = useState("");
  const [company, setCompany] = useState(null);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const compRes = await axios.get(`/api/companydetails/${companyId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCompany(compRes.data);
        const packageRes = await axios.get(`/api/package/companyId=${companyId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const designationRes = await axios.get(`/api/designation/${designationId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPackages(packageRes.data);
        setDesignations(designationRes.data);
      } catch (error) {
       handleError(error);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const payload = [];
  
  if (company?.packageByAge === false && company?.restrictedPkgByDesignation === true) {
      // Case 2: Only gender-based
      if (!designationPackage.packageid || designationPackage.gender.length === 0) {
        setLoading(false);
        toast.error("Please select package and at least one gender.");
        return;
      }
  
      designationPackage.gender.forEach((gender) => {
        payload.push({
          packageid: designationPackage.packageid,
          designationid: designationId,
          gender,
          age: null,
        });
      });
  
    } else if ((company?.packageByAge === true && company?.restrictedPkgByDesignation === false)||(company?.packageByAge === true && company?.restrictedPkgByDesignation === true) ) {
      // ✅ Case 3: Both age and gender-based
      if (
        !designationPackage.packageid ||
        selectedAges.length === 0 ||
        designationPackage.gender.length === 0
      ) {
        setLoading(false);
        toast.error("Please select package, at least one age and one gender.");
        return;
      }
  
      designationPackage.gender.forEach((gender) => {
        selectedAges.forEach((age) => {
          payload.push({
            packageid: designationPackage.packageid,
            designationid: designationId,
            gender,
            age,
          });
        });
      });
  
    } 
    try {
      await axios.post("/api/packagedesignationmapping/create", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      setLoading(false);
      onRequestClose();
      setDesignationPackage({ packageid: "", designationid: designationId, gender: [], age: [] });
      setSelectedAges([]);
      toast("Designation and Package mapped successfully");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };
  
  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

   const [selectedAges, setSelectedAges] = useState([]);
  
    // Generate age list from 18 to 100
    const ageOptions = Array.from({ length: 83 }, (_, i) => 18 + i);
  
    const toggleAgeSelection = (age) => {
      setSelectedAges((prevSelected) =>
        prevSelected.includes(age)
          ? prevSelected.filter((a) => a !== age)
          : [...prevSelected, age]
      );
    };

    const rhandle = (e) => {
      const { id, value, checked } = e.target;
      if (id === "gender") {
        setDesignationPackage((prevState) => ({
          ...prevState,
          gender: checked
            ? [...prevState.gender, value]
            : prevState.gender.filter((g) => g !== value),
        }));
      } else if (id === "packageid") {
        setDesignationPackage((prevState) => ({
          ...prevState,
          [id]: value,
        }));
      }
    };
    

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Package and Designations Mapping</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="loading"></div>}
        <div className="col-xl-10 mx-xl-auto">
          <div className="card card-raised mb-3">
            <div className="card-body p-4 ">
              <form onSubmit={handleSubmit}>
                <div className="row">

                <div className="form-floating-sm mb-2">
                    <label htmlFor="designation">Designation</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Designation"
                      value={designations.designation}
                      readOnly
                    />
                  </div>
                
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="packageid">
                      Package <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-control"
                      id="packageid"
                      value={designationPackage.packageid}
                      onChange={(e) => rhandle(e)}
                      required
                    >
                      <option value="">Select Package</option>
                      {packages.map((pkg) => (
                        <option key={pkg.id} value={pkg.id}>
                          {pkg.packagename}
                        </option>
                      ))}
                    </select>
                  </div>
                  {company?.packageByAge===true && (
                      <div className="mb-2">
                      <label htmlFor="age">
                        Age <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="dropdown">
                        <button
                          className="form-control text-start dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {selectedAges.length > 0
                            ? selectedAges.sort((a, b) => a - b).join(", ")
                            : "Select Age(s)"}
                        </button>
                        <ul
                          className="dropdown-menu p-2"
                          style={{ maxHeight: "200px", overflowY: "auto", width: "100%" }}
                        >
                          {ageOptions.map((age) => (
                            <li key={age} className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value={age}
                                id={`age-${age}`}
                                checked={selectedAges.includes(age)}
                                onChange={() => toggleAgeSelection(age)}
                              />
                              <label className="form-check-label" htmlFor={`age-${age}`}>
                                {age}
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                
                  )}
                 
                 
                  <div className="form-floating-sm mb-2">
                    <label>
                      Gender <span style={{ color: "red" }}>*</span>
                    </label>
                    <div>
                      <label htmlFor="male">
                        <input
                          type="checkbox"
                          id="gender"
                          value="Male"
                          checked={designationPackage.gender.includes("Male")}
                          onChange={(e) => rhandle(e)}
                        />{" "}
                        Male
                      </label>
                    </div>
                    <div>
                      <label htmlFor="female">
                        <input
                          type="checkbox"
                          id="gender"
                          value="Female"
                          checked={designationPackage.gender.includes("Female")}
                          onChange={(e) => rhandle(e)}
                        />{" "}
                        Female
                      </label>
                    </div>
                  </div>
                 
                </div>
                
                <div className="mt-3">
                <input
                  type="submit"
                  value="SAVE"
                  className="btn btn-primary"
                  disabled={loading}
                />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Button variant="secondary" onClick={onRequestClose}>
                  Close
                </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

export default MapDesignationsAndPackage;
